/* Styles */
import "../style/base/_common.scss";
import "../style/components/_utilities.scss";
import "../style/components/_transitions.scss";
import "../style/components/_grid.scss";
import "../style/components/_nav.scss";
import "../style/components/_modal.scss";
import "../style/components/_breadcrumb.scss";
import "../style/components/_buttons.scss";
import "../style/components/_images.scss";
import "../style/components/_forms.scss";
import "../style/components/_box.scss";
import "../style/components/_card.scss";
import "../style/layout/_cookie.scss";
import "../style/layout/_header.scss";
import "../style/layout/_details.scss";
import "../style/layout/_insertion.scss";
import "../style/layout/_pagination.scss";
import "../style/layout/_footer.scss";
import "../style/vendor/_siema.scss";
import "../style/pages/real-estate.scss";

/* JS */

import "bootstrap/js/dist/tab";

import "./components/menu";
import "@wikicasa/common/lazy";
import "@wikicasa/common/select";

import Siema from "@wikicasa/common/carousel";

import stickybits from "stickybits";

import * as Common from "@wikicasa/common/common";
import * as Icons from "@wikicasa/common/icons";
import LeafletMap from "@wikicasa/common/leaflet_map";
import * as Favourite from "./components/favourite";
import * as Share from "@wikicasa/common/share";
import * as Ads from "@wikicasa/common/ads";
import * as Pagination from "@wikicasa/common/pagination";
import type {ChartConfiguration} from "chart.js";
import type {IPagination} from "@wikicasa/common/pagination";
import type {IContact} from "./components/contact";
import Cleave from "cleave.js";
import {EMAIL_REGEX_INTO_TEXT, PHONE_REGEX, DATE_REGEX, EXCLUDED_REGEX, COMPETITOR_REGEX} from "@wikicasa/common/common";


const charts: Array<any> = [];

const map = new LeafletMap();

let Contact: IContact;

$(() => {

    const $backURL = $(".backURL");



    Pagination.init().then(() => Pagination.getPagination()
        .then((pagination: IPagination) => {
            updateViewDetail(pagination);

            if (pagination?.fromMap) {
                $backURL.on("click", (e: JQuery.Event) => {
                    e.preventDefault();
                    window.close();
                });
                $backURL.find("span").text(window["_mapLabel"]);
            }
        }));


    initContact();
    initCarousel();
    initDescription();

    if (window["_priceSale"])
        initRataMutuo();


    Favourite.init();

    initRealEstateMap();

    Share.init();


    initReportIssue();

    stickybits("#detail-navbar", {
        useStickyClasses: true,
    });

    stickybits("#mobile-details", {
        useStickyClasses: true,
        stickyBitStickyOffset: 43
    })

    stickybits("#detail-header", {
        useStickyClasses: true,
    });

    stickybits("#agency-contact", {
        useStickyClasses: true,
        stickyBitStickyOffset: 180
    });

    Ads.init();

    $("#similar-real-estates").on("click", ".insertion", function() {
        window.location.href = $(this).data("url");
    });

    $("#icon-click-map").on("click", () => {
        const mapElem = document.getElementById("map")!;
        mapElem.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    });
});

function initDescription(): void {

    const $description = $("#description");
    const $showMore = $("#show-more");

    let text = $description.html().trim();

    text = text.replace(EMAIL_REGEX_INTO_TEXT,"***");
    text = text.replace(COMPETITOR_REGEX,"***");
    text = text.replace(PHONE_REGEX, (match: string, p1: never, p2: never, p3: never, offset: number) => {

        if (p1) return match;
        if (match.match(DATE_REGEX))
            return match;

        const start = Math.max(0, offset - 6);
        const tmp = text.substring(start, offset).toLowerCase();
        return EXCLUDED_REGEX.some((s: string) => tmp.indexOf(s.toLowerCase()) > -1) ? match : "***";
    });

    $description.html(text);

    $showMore.on("click", () => {
        $showMore.hide();
        $description.removeClass("description-collapsed");
    });
    if (text.length < 500) {
        $showMore.trigger("click");
    }
}

function initCarousel(): void {

    const $modalCarousel = $("#modal-carousel");

    const $navMedia = $("#nav-media");
    const $tabMedia = $("#tab-media");
    const $navMediaFull = $("#nav-media-full");
    const $tabMediaFull = $("#tab-media-full");

    document.onkeydown = ((e: KeyboardEvent): void => {
        const $selector = $modalCarousel.hasClass("show") ? $tabMediaFull : $tabMedia;

        const siema = $selector.find(".active .siema").data("siema");

        if (!siema || !e.code)
            return;

        switch (e.code){
            case "ArrowLeft":
                siema.prev();
                break;
            case "ArrowRight":
                siema.next();
                break;
        }
    });

    Common.observe(".siema", (elem: HTMLElement) => {

        const $elem = $(elem);

        const opts: Record<string, any> = {
            selector: elem,
            loop: $elem.data("count") > 1,
            perPage: {
                576: $elem.data("page-size") || 1
            },
            onInit: function (): void {

                const self = this as Record<string, any>;

                self.lazyLoad();
                self.addArrows();

                if ($elem.data("thumbnails"))
                    self.addThumbnails();
            }
        };

        if ($elem.data("label")) {

            const $label = $($elem.data("label"));

            const $number = $label.find(".number");
            const $count = $label.find(".count");

            $count.text($elem.data("count"));

            opts["onChange"] = function (): void {
                $number.text(this.currentSlide + 1);
            };
        }

        const siema = new Siema(opts);

        $elem.data("siema", siema);
    });

    $modalCarousel.on("shown.bs.modal hidden.bs.modal", () => window.dispatchEvent(new Event("resize")));
    $navMedia.find(".nav-link").on("shown.bs.tab", () => window.dispatchEvent(new Event("resize")));
    $navMediaFull.find(".nav-link").on("shown.bs.tab", function () {

        $modalCarousel.find(".carousel-label").hide();

        const $this = $(this);

        if ($this.data("label"))
            $($this.data("label")).show();

        window.dispatchEvent(new Event("resize"));
    });
}

function initContact(): void {

    $("#request-modal").on("show.bs.modal", (e: JQuery.EventBase) => {

        const data = $(e.relatedTarget || "").data("data");

        $("#request-modal-body").toggle(!data.externalURL);
        $("#request-modal-body-externalURL").toggle(!!data.externalURL);
        $("#request-modal-body-externalURL a").attr("href", data.externalURL);

        import(/* webpackChunkName: "chunks/contact" */ "./components/contact").then((module: any) => {

            if (!Contact) {
                Contact = module;
                Contact.init();
            }

            Contact.showDialogContact(data);
        });

    });

    $(document).on("click", "[data-phone]", function (e: JQuery.Event) {
        e.preventDefault();

        const self = this;

        import(/* webpackChunkName: "chunks/contact" */ "./components/contact").then((module: any) => {

            if (!Contact) {
                Contact = module;
                Contact.init();
            }

            Contact.showPhone(e, $(self));
        });
    });

}

function initRealEstateMap(): void {

    const $map = $("#map");

    const lat = $map.data("lat");
    const lng = $map.data("lng");

    if (!map.validateCoordinate(lat, lng)) {
        $map.remove();
        return;
    }
}


let $installment: JQuery;

let $boxMortgage:JQuery;
let $boxMortgageError: JQuery;
let $modalMortgage: JQuery<HTMLElement>;
let $modalMortgageCalculate: JQuery<HTMLElement>;
let $modalMortgageButton: JQuery<HTMLElement>;
let $modalMortgageLink: JQuery<HTMLElement>;
let $duration: JQuery;
let $amount: JQuery;
let cAmount: Cleave;
let $totalAmount: JQuery;
let $totalAdvance: JQuery;
let $totalDuration: JQuery;
let amountTimeout: number;
let $tan: JQuery;
let $taeg: JQuery;
let $taxVariable: JQuery;
let $taxFixed: JQuery;

const MIN_MORTGAGE = 30000;


function initRataMutuo(): void {

    $installment = $(".mortgage-installment");
    $boxMortgage = $("#box-mortgage");
    $boxMortgageError = $("#mortgage-error");
    $modalMortgage = $("#modal-mortgage");
    $modalMortgageCalculate = $("#modal-mortgage-calculate");
    $modalMortgageButton = $(".btn-modal-mortgage");
    $modalMortgageLink = $(".link-modal-mortgage");
    $duration = $("#mortgage-duration");
    $amount = $("#mortgage-amount");
    $totalAdvance = $(".total-advance");
    $totalAmount = $(".total-amount");
    $totalDuration = $(".total-duration");
    $tan = $(".mortgage-tan");
    $taeg = $(".mortgage-taeg");
    $taxVariable = $("#mortgage-tax-variable");
    $taxFixed = $("#mortgage-tax-fixed");

    updateRataMutuo();

    if (!$boxMortgage.length)
        return;

    $modalMortgageButton.click(() => {

        if (validate())
            $modalMortgage.modal("show");
        else
            $modalMortgageCalculate.modal("show");
    });

    $modalMortgageLink.click(() => {
        $modalMortgage.modal("show");
    });

    Common.observe("#box-mortgage", (elem: HTMLElement, observer: IntersectionObserver) => {

        import(/* webpackChunkName: "chunks/cleave" */  "cleave.js").then((module: any) => {

            const Cleave = module.default;

            cAmount = new Cleave($amount, {
                numeral: true,
                numeralThousandsGroupStyle: "thousand",
                numeralDecimalScale: 0,
                delimiter: ".",
                numeralDecimalMark: ",",
                numeralPositiveOnly: true,
            });

            let tempAmount = window["_priceSale"]* .8;

            if (tempAmount < MIN_MORTGAGE){
                tempAmount = MIN_MORTGAGE;
            }

            const amount = tempAmount;

            cAmount.setRawValue(amount.toString());

            $amount.keyup(() => {
                clearTimeout(amountTimeout);
                amountTimeout = window.setTimeout(() => {

                    if (!validate())
                        return;

                    updateRataMutuo();
                    drawChart();
                }, 500);
            });

            $taxVariable.add($taxFixed).add($duration).change(() => {
                updateRataMutuo();
                drawChart();
            });

            drawChart();
        });

        observer.disconnect();
    });
}

function validate(): boolean {

    let valid = true;

    if (cAmount.getRawValue() > window["_priceSale"]) {
        $boxMortgageError.html(window["_mortgageMaxLabel"]);
        $boxMortgageError.show();
        $amount.addClass("has-error");
        valid = false;
    }

    if (Number(cAmount.getRawValue()) < MIN_MORTGAGE) {
        $boxMortgageError.text(window["_mortgageMinLabel"]);
        $boxMortgageError.show();
        $amount.addClass("has-error");
        valid = false;
    }

    if (valid) {
        $boxMortgageError.hide();
        $amount.removeClass("has-error");
    }

    return valid;
}


function updateRataMutuo(): void {

    let amount = window["_priceSale"] - ((window["_priceSale"] * 20) / 100);
    let duration = 25;
    let tax = "Variabile";

    if ($boxMortgage.length && cAmount) {
        amount = Number(cAmount.getRawValue());
        duration = Number($duration.val());
        tax = $taxVariable.is(":checked") ? $taxVariable.attr("value") || "" : $taxFixed.attr("value") || "";
    }
    $boxMortgage.data("amount", amount);

    const data: Record<string, any> = {
        "tasso": tax,
        "importo": Math.round(amount),
        "durata": duration
    };


    data["finalita"] = "Acquisto";
    data["costo"] = Math.round(window["_priceSale"]);

    $.ajax({
        url: "/rest/realEstate/getFacileData",
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: (data: Record<string, any>) => {
            const tan = Number(data["tasso"]) ? Common.formatFloat(Number(data["tasso"])) : undefined;
            const taeg = Number(data["taeg"]) ? Common.formatFloat(Number(data["taeg"])) : undefined;
            const installment = Common.formatInteger(Math.round(Number(data["rata_eff"])));
            $boxMortgage.data("mortgage", data)
            $installment.html(installment);

            if (!$boxMortgage.length)
                return;

            if (tan) {
                $tan.find("span").html(`${tan}%`);
                $tan.removeClass("hide");
            } else {
                $tan.addClass("hide");
            }

            if (taeg) {
                $taeg.find("span").html(`${taeg}%`);
                $taeg.removeClass("hide");
            } else {
                $taeg.addClass("hide");
            }
        },
        error: (error: any) => {
            console.error(error);
        }
    });
}


function drawChart(): void {

    import(/* webpackChunkName: "chunks/cleave" */  "chart.js").then((module: any) => {

        const Chart = module.default;

        const amount = parseInt(cAmount.getRawValue());
        const diff = window["_priceSale"] - amount;
        const duration = Number($duration.val());

        $totalAdvance.text(Common.formatInteger(diff));
        $totalAmount.text(Common.formatInteger(amount));
        $totalDuration.text(duration);

        const contexts = document.getElementsByClassName("mortgage-chart") as HTMLCollectionOf<HTMLCanvasElement>;

        for (let i = 0; i < charts.length; i++) {
            charts[i].destroy();
        }

        const options = {
            type: "doughnut",
            data: {
                datasets: [{
                    data: [amount, diff],
                    backgroundColor: ["#FE600B", "#c5c3c6"],
                }],
                labels: [window["_mortgageLabel"], window["_equityCapitalLabel"]]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage: 80,
                responsive: true,
                maintainAspectRatio: true,
                tooltips: {
                    enabled: false
                },
                layout: {
                    margin: {
                        bottom: 200
                    }
                },
                plugins: {
                    datalabels: {
                        backgroundColor: function (context: HTMLCanvasElement): string | undefined {
                            return context.dataset.backgroundColor;
                        },
                        borderColor: "white",
                        borderRadius: 2,
                        borderWidth: 2,
                        color: "white",
                        font: {
                            weight: "bold"
                        },
                        formatter: (value: string): string => {
                            return Number(value).toLocaleString("it-IT", {
                                style: "currency",
                                currency: "EUR",
                                minimumFractionDigits: 0
                            });
                        }
                    }
                }
            }
        } as ChartConfiguration;

        for (let i = 0; i < contexts.length; i++) {
            charts.push(new Chart(contexts[i], options));
        }

    });
}


$("#mortgage_modal").on("click", function (e: JQuery.Event) {

    e.preventDefault();

    const $btn = $(this);

    Icons.addSpinner($btn);

    //Lorenzo: disable all fields, prevent the request from being re-submitted and generate duplicates
    const form = $btn.closest("form");

    const fields = form.find("input, textarea");

    fields.attr("disabled", "disabled").removeClass("has-error");

    const id = $btn.attr("id");

    const $name = $("#" + id + "_name");
    const $surname = $("#" + id + "_surname");
    const $phone = $("#" + id + "_phone");
    const $email = $("#" + id + "_email");
    const $privacy = $("#" + id + "_privacy");

    //Lorenzo: basic validation (replied on server side)
    let hasError = false;

    if (!$name.val()) {
        hasError = true;
        $name.addClass("has-error");
    }

    const mailRegex = new RegExp("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$");

    if (!$email.val() || !mailRegex.test(String($email.val()))) {
        hasError = true;
        $email.addClass("has-error");
    }

    // eslint-disable-next-line max-len
    const phoneRegex = new RegExp("^(\\+?[0-9][\\s.\\-\\\\/]?[0-9]{0,3}|\\+?[0-9]{2,4}[\\s.\\-\\\\/]?[0-9]?)?(\\s\\.-\\\\/)?([0-9]{2,4}[\\s.\\-\\\\/]?)?([\\s.\\-\\\\/]?[0-9]+)+$");

    if (!$phone.val() || !phoneRegex.test(String($phone.val()))) {
        hasError = true;
        $phone.addClass("has-error");
    }

    if (!$privacy.is(":checked")) {
        hasError = true;
        $privacy.addClass("has-error");
    }

    if (hasError) {
        fields.removeAttr("disabled");
        Icons.removeSpinner($btn);
    } else {
        const dataMortgage = $boxMortgage.data("mortgage");
        const mortgageAmount = $("#mortgage-amount").val() as string;

        let tempImporto = window["_priceSale"]* .8;

        if (tempImporto < 30000){
            tempImporto = 30000;
        }
        let importo = tempImporto;
        if(cAmount){
            importo = Number(cAmount.getRawValue())
        }

        const rate = $taxVariable.is(":checked") ? $taxVariable.attr("value") || "" : $taxFixed.attr("value") || "";
        const amount = Math.round(importo);
        const tan = parseFloat(dataMortgage.tasso);
        const installment = parseInt(dataMortgage.rata_eff);

        const params = {
            name: $name.val(),
            surname: $surname.val(),
            email: $email.val(),
            phone: $phone.val(),
            price: window["_priceSale"],
            duration: $duration.val(),
            amount: amount,
            url: $btn.data("product-url"),
            realEstateId: window["_referenceId"],
            tanValue: tan,
            rate: rate,
            installment: installment,
            tenantId: 2
        };

        $.ajax({
            type: "POST",
            url: "/rest/agency/sendMutuo",
            data: JSON.stringify(params),
            contentType: "application/json",
            crossDomain: true,
            success: () => {
                $btn.html(`<i class="fas fa-check mr-025"></i> ${window["_genericSendOkLabel"]}!`);
                $btn.removeClass("btn-primary").addClass("btn-success");
                $("#modal-mortgage").modal("hide");
                $("#modal_mortgage_ok").modal("show");
                setTimeout(function (){
                    $("#modal_mortgage_ok").modal("hide");
                }, 3000);

                window["dataLayer"].push({
                    "event": "GAevent",
                    "eventCategory": "Preventivo Mutuo",
                    "eventAction": "Invio richiesta",
                    "eventLabel": "Box",
                    //GA4
                    "event_name": "mortgage_lead",
                    "event_location": "Box Mutuo",
                });
            },
            error: () => {
                fields.removeAttr("disabled");
                const $alert = $("<p class=\"mt-05\">Attenzione: si &egrave; verificato un errore con la richiesta</p>").css("color", "red");
                $btn.after($alert);
                setTimeout(() => {
                    $alert.remove();
                }, 5000);
                Icons.removeSpinner($btn);
            }
        });
    }

});


function initReportIssue(): void {

    $("#report_issue").click(function (e: JQuery.Event) {
        e.preventDefault();

        const $btn = $(this);

        Icons.addSpinner($btn);

        const form = $btn.closest("form");

        const fields = form.find("input, textarea");

        fields.attr("disabled", "disabled").removeClass("has-error");

        const id = $btn.attr("id");
        const url = $btn.data("url");

        const $error = $("#" + id + "_error");
        const $name = $("#" + id + "_name");
        const $email = $("#" + id + "_email");
        const $notes = $("#" + id + "_notes");
        const $privacy = $("#" + id + "_privacy");

        let hasError = false;

        if (!$error.val()) {
            hasError = true;
            $error.addClass("has-error");
        }

        const mailRegex = new RegExp("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$");
        if (!$email.val() || !mailRegex.test(String($email.val()))) {
            hasError = true;
            $email.addClass("has-error");
        }

        if (!$privacy.is(":checked")) {
            hasError = true;
            $privacy.addClass("has-error");
        }

        if (hasError) {
            fields.removeAttr("disabled");
            Icons.removeSpinner($btn);
        } else {

            $.ajax({
                type: "POST",
                url: "/rest/realEstate/sendErrorReport",
                data: JSON.stringify({
                    type: $error.val(),
                    realEstateID: window["_referenceId"],
                    agencyID: window["_agencyId"],
                    name: $name.val(),
                    email: $email.val(),
                    notes: $notes.val(),
                    url: url
                }),
                contentType: "application/json",
                success: () => {
                    $btn.html(`<i class="fas fa-check mr-025"></i> ${window["_genericSendOkLabel"]}!`);
                    $btn.removeClass("btn-primary").addClass("btn-success");
                },
                error: () => {
                    fields.removeAttr("disabled");
                    const $alert = $("<p class=\"mt-05\">Attenzione: si &egrave; verificato un errore con la richiesta</p>").css("color", "red");
                    $btn.after($alert);
                    setTimeout(() => {
                        $alert.remove();
                    }, 5000);
                    Icons.removeSpinner($btn);
                }
            });
        }
    });
}

function updateViewDetail(pagination: IPagination): void {

    if (window["_bot"])
        return;

    const data = {
        agencyId: window["_agencyId"],
        realEstateId: window["_referenceId"],
        fromListing: false
    };

    if (pagination?.fromListing) {
        data.fromListing = true;
        pagination.fromListing = false;
        Pagination.writePagination(pagination);
    }

    $.ajax({
        method: "POST",
        contentType: "application/json",
        url: "/rest/statistics/updateViewDetail/C",
        data: JSON.stringify(data)
    });
}